import { createAction } from '@ngrx/store';

import { GTMDotCMSContentlet } from 'ish-core/models/gtm/gtm.model';
import { Payment } from 'ish-core/models/payment/payment.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { ShippingMethod } from 'ish-core/models/shipping-method/shipping-method.model';
import { payload } from 'ish-core/utils/ngrx-creators';

export const triggeringViewPromotionGTMEvent = createAction(
  '[Google Tag Manager] Trigger GTM View Promotion Events',
  payload<{ event: string; item: GTMDotCMSContentlet[] }>()
);

export const triggeringSelectPromotionGTMEvent = createAction(
  '[Google Tag Manager] Trigger GTM Select Promotion Events',
  payload<{ event: string; item: GTMDotCMSContentlet[] }>()
);

export const triggeringViewItemGTMEvents = createAction(
  '[Google Tag Manager] Trigger view Item GTM Events',
  payload<{ event: string; item: ProductView[] }>()
);
export const triggeringViewItemGTMEvent = createAction(
  '[Google Tag Manager] Trigger view Item GTM Event',
  payload<{ event: string; item: ProductView[] }>()
);
export const triggerGTMRemoveToCart = createAction(
  '[Google Tag Manager] Trigger Google Tag Manager Remove From Cart Event'
);
export const triggerBeginCheckoutGTMEvent = createAction(
  '[Google Tag Manager] Trigger Google Tag Manager Begin Checkout Event'
);

export const triggerReviewCheckoutGTMEvent = createAction(
  '[Google Tag Manager] Trigger Google Tag Manager Review Checkout Event'
);

export const triggerPaymentMethodGTMEvent = createAction(
  '[Google Tag Manager] Trigger Google Tag Manager Checkout Payment Method Event',
  payload<{ payment: Payment }>()
);
export const triggerShippingMethodGTMEvent = createAction(
  '[Google Tag Manager] Trigger Google Tag Manager Checkout Shipping Method Event',
  payload<{ shipping: ShippingMethod }>()
);
export const triggeringSearchGTMEvent = createAction(
  '[Google Tag Manager] Trigger Search GTM Event',
  payload<{ searchTerm: string }>()
);
